const $ = jQuery.noConflict();
const sectionClass = $('.wp-block-e25m-custom-location-map');
const regionClass = sectionClass.find('.region');
const regionClassTitle = $('.region > p');
const mapTag = $("#map");
let markers = [];
let map = null;
let bounds = null;
let infowindow = null;


function initMap() {
	if (sectionClass.length) {

		$("#myDiv").show();
		const defaultCoordinates = {
			lat: sectionClass.data("latitude"),
			lng: sectionClass.data("longitude")
		};
		map = new google.maps.Map(document.getElementById("map"), {
			zoom: 4,
			center: defaultCoordinates,
			styles: [
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e9e9e9"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dedede"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#333333"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f2f2f2"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
					]
				}
			]
		})
	}
}

function setScrollWhenClickMap() {

	let scrollTop = mapTag.offset().top - $("header").outerHeight();
	const body = $("body");

	if($(window).width() > 991 ){
		if(body.hasClass("has-inner-menu")){
			scrollTop  -= $("li.mega-sub-menu-added > .mega-sub-menu").outerHeight();
		}
		if(body.hasClass("admin-bar")){
			scrollTop = scrollTop - 32;
		}
	}
	$("html, body").animate({scrollTop: scrollTop}, 600);
}

window.initMap = initMap;

function setMapOnAll(map) {
	for (let i = 0; i < markers.length; i++) {
		markers[i].setMap(map);
	}
}

function addMarker(position) {
	const marker = new google.maps.Marker({
		position,
		map,
		icon: {
			path: google.maps.SymbolPath.CIRCLE,
			scale: 0
		}
	});

	markers.push(marker);
	return marker;
}

regionClassTitle.on('click', (event) => {
	let accordion = $(event.target);
	setMapOnAll(null);
	markers = [];
	bounds = new google.maps.LatLngBounds();
	accordion.next().children().each((index, singleEl) => {
		singleEl = $(singleEl);
		let coordinates = {
			lat: parseFloat(singleEl.data('latitude')),
			lng: parseFloat(singleEl.data('longitude'))
		};
		let marker = addMarker(coordinates);

		singleEl.data('marker', markers.indexOf(marker))

		bounds.extend(coordinates);
		map.fitBounds(bounds);
		map.setZoom(14);
	})
});

$('li.wp-block-e25m-custom-location-map-single-accordion-element > p').on('click', (event) => {
	const p = $(event.target);
	const singleEl = p.parent();
	if (infowindow) {
		infowindow.close();
	}
	const localInfowindow = new google.maps.InfoWindow({
		content: `<div class="location-details">${singleEl.html()}</div>`,
		ariaLabel: p.text(),
	});
	localInfowindow.open({
		anchor: markers[singleEl.data('marker')],
		map,
	});
	infowindow = localInfowindow;
	if ($(window).width() > 991) {
		setTimeout(
			() => map.panTo(new google.maps.LatLng(singleEl.data('latitude'), singleEl.data('longitude'))),
			500
		);
	}
	setScrollWhenClickMap();
});